// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"5ccdeb71","120":"0bb3acbd","625":"a0d15ac9","642":"e3b134bc","998":"ed2ec848"}[chunkId] + ".chunk.js";
};